import { isCreatorProgramFlowPath, isCreatorStudioPath } from './creatorProgramPaths';

export type MainNavLink = {
  path: string;
  name: string;
};

/**
 * Public navbar — buyer discovery first. Creator Program lives in footer and account flows.
 */
export const PUBLIC_NAV_LINKS: MainNavLink[] = [
  { path: '/shop', name: 'Shop' },
  { path: '/design-tool', name: 'Design Your Own' },
  { path: '/about', name: 'About' },
];

export type NavbarChrome = {
  centerLinks: MainNavLink[];
  showWishlist: boolean;
  showCart: boolean;
  showGuestAuth: boolean;
  showAccount: boolean;
  showWishlistShortcut: boolean;
  showCartShortcut: boolean;
};

export type BuildNavbarChromeOptions = {
  isAuthenticated: boolean;
  pathname?: string;
};

function filterCurrentPageLink(
  links: MainNavLink[],
  pathname: string,
): MainNavLink[] {
  return links.filter((link) => {
    if (
      link.path === '/shop' &&
      (pathname === '/shop' || pathname.startsWith('/shop/'))
    ) {
      return false;
    }
    if (link.path === '/about' && pathname.startsWith('/about')) {
      return false;
    }
    if (
      link.path === '/design-tool' &&
      (pathname === '/design-tool' || pathname.startsWith('/design-tool'))
    ) {
      return false;
    }
    if (
      link.path === '/creator-program' &&
      (isCreatorProgramFlowPath(pathname) || isCreatorStudioPath(pathname))
    ) {
      return false;
    }
    return true;
  });
}

/**
 * Public navbar chrome — same discovery nav, cart, and CTAs for all users.
 * Role-specific routes live in the account dropdown / mobile account sheet only.
 */
export function buildNavbarChrome(
  options: BuildNavbarChromeOptions,
): NavbarChrome;
/** @deprecated Pass a single options object instead. */
export function buildNavbarChrome(
  isAuthenticated: boolean,
  _roles?: unknown,
  _cartItemCount?: number,
): NavbarChrome;
export function buildNavbarChrome(
  optionsOrAuth: BuildNavbarChromeOptions | boolean,
): NavbarChrome {
  const options: BuildNavbarChromeOptions =
    typeof optionsOrAuth === 'boolean'
      ? { isAuthenticated: optionsOrAuth, pathname: '/' }
      : optionsOrAuth;

  const { isAuthenticated, pathname = '/' } = options;
  const centerLinks = filterCurrentPageLink(PUBLIC_NAV_LINKS, pathname);

  if (!isAuthenticated) {
    return {
      centerLinks,
      showWishlist: false,
      showCart: true,
      showGuestAuth: true,
      showAccount: false,
      showWishlistShortcut: false,
      showCartShortcut: true,
    };
  }

  return {
    centerLinks,
    showWishlist: true,
    showCart: true,
    showGuestAuth: false,
    showAccount: true,
    showWishlistShortcut: true,
    showCartShortcut: true,
  };
}

/** @deprecated Use PUBLIC_NAV_LINKS or buildNavbarChrome().centerLinks */
export function buildMainNavLinks(_isOwner?: boolean): MainNavLink[] {
  return [...PUBLIC_NAV_LINKS];
}
